import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M111.8 156.4h66.3l73.6-73.6s19.3 2.4 24.9 8.1c5.6 5.6 8.3 25.2 8.3 25.2l-69.5 69.5v49.2H74.5v-49.2L5 116s2.7-19.5 8.3-25.2c5.6-5.6 24.9-8.1 24.9-8.1l73.6 73.7zm33.2-7.1c25.9 0 47-21 47-47s-21-47-47-47-47 21-47 47 21.1 47 47 47z"
})), 'FanFilledIcon');